import styled from "styled-components"
import { BsTelephoneInboundFill } from "react-icons/bs";
import { SiGmail } from "react-icons/si";
import { ImLocation2 } from "react-icons/im";
import { AiFillLinkedin, AiFillGithub, AiFillMail } from "react-icons/ai";

export const Contact = () => {
    return (
        <DIV id='contact'>
            <h1>Contact</h1>
            <div className="contacts_div">
                <div>
                    <BsTelephoneInboundFill className="phone"></BsTelephoneInboundFill>
                    <h2>+91 7983007098</h2>
                </div>
                <div>
                    <SiGmail className="gmail"></SiGmail>
                    <h2>amirhamdard07@gmail.com</h2>
                </div>
                <div>
                    <ImLocation2 className="location"></ImLocation2>
                    <h2>New Delhi, India</h2>
                </div>
            </div>
            <div className="icon_div">
                <a href="https://www.linkedin.com/in/amir-khan-5a6171199">
                    <AiFillLinkedin className="icon"></AiFillLinkedin>
                </a>
                <a href="https://github.com/amir241297">
                    <AiFillGithub className="icon"></AiFillGithub>
                </a>
                <a href="https://mail.google.com/mail/u/1/#inbox?compose=new">
                    <AiFillMail className="icon"></AiFillMail>
                </a>
            </div>
        </DIV>
    )
}

const DIV = styled.div`
    margin-top: 100px;
    margin-bottom: 50px;
    
    .contacts_div{
        display: flex;
        width: 60%;
        margin: auto;
        justify-content: space-around;
        font-weight: 500;
    }
    .contacts_div>div{
        display: flex;
        align-items: center;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        height: 30px;
        padding: 10px;
    }
    .contacts_div>div:hover{
        cursor: pointer;
        background-color: blueviolet;
        border-radius: 5px;
    }
    .phone{
        color: #1ecd1e;
        margin-right: 10px;
    }
    .gmail{
        color: rgba(199,22,16);
        margin-right: 10px;
    }
    .location{
        color: rgba(199,22,16);
        margin-right: 10px;
    }
   

    @media (max-width: 480px) {
        /* screen width is less than 480px (Phone) */
        width: 100%;

    h1{
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 30px;
    }
    h2{
        font-size: 15px;
        font-weight: 600;
    }
    .contacts_div{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .contacts_div>div{
        margin-bottom: 10px;
    }

    .icon{
        font-size: 30px;
    }
    .icon_div{
        width: 80%;
        display: flex;
        justify-content: space-around;
        margin: auto;
        margin-top: 30px;
    }
    }
    @media (min-width: 481px) and (max-width: 768px) {
    /* screen width is between 481px (medium) and 768px (IPad) */
        width: 100%;

    h1{
        font-size: 35px;
        font-weight: 600;
        margin-bottom: 30px;
    }
    h2{
        font-size: 17px;
        font-weight: 600;
    }
    .contacts_div{
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .contacts_div>div{
        margin-bottom: 15px;
    }

    .icon{
        font-size: 35px;
    }
    .icon_div{
        width: 80%;
        display: flex;
        justify-content: space-around;
        margin: auto;
        margin-top: 30px;
    }
    }
    @media (min-width: 769px) and (max-width: 1200px) {
    /* screen width is between 769px (medium) and 1024px (large) (Tablet)*/
    width: 100%;
    h1{
        font-size: 50px;
        font-weight: 600;
        margin-bottom: 30px;
    }
    h2{
        font-size: 20px;
        font-weight: 600;
    }
    .contacts_div{
        display: flex;
    flex-direction: row ;
    justify-content: space-around;
        width: 100%;
    }
    .contacts_div>div{
        /* margin-bottom: 15px; */
        display: flex;
    }

    .icon{
        font-size: 40px;
    }
    .icon_div{
        width: 50%;
        display: flex;
        justify-content: space-around;
        margin: auto;
        margin-top: 30px;
    }
    }
    @media (min-width: 1201px){ 
    /* screen width is greater than 1200px (large) */
    h1{
        font-size: 40px;
        font-weight: 600;
        margin-bottom: 30px;
    }
     .icon{
        font-size: 40px;
    }
    .icon_div{
        width: 20%;
        display: flex;
        justify-content: space-around;
        margin: auto;
        margin-top: 50px;
    } 
    }
`